var _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgSearchWhite = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    rol: "img",
    alt: "search",
    "aria-label": "search",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    fillRule: "evenodd",
    d: "M19.344 16.22l-4.62-4.58a7.674 7.674 0 0 0 1.035-3.849C15.759 3.488 12.23 0 7.879 0 3.528 0 0 3.488 0 7.791c0 4.303 3.528 7.792 7.88 7.792a7.913 7.913 0 0 0 3.708-.918l-.07.07 4.658 4.616c.437.433 1.01.649 1.584.649.573 0 1.147-.216 1.584-.649a2.197 2.197 0 0 0 0-3.132zM7.879 13.28c-3.065 0-5.55-2.458-5.55-5.488 0-3.032 2.485-5.489 5.55-5.489 3.066 0 5.55 2.457 5.55 5.489 0 3.03-2.484 5.488-5.55 5.488z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSearchWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/search_white.7a2f3dd2.svg";
export { ForwardRef as ReactComponent };